export const INITIAL_EMAIL_BODY = `Please commence tasks as indicated on the attached SOF Document.\n\nThank you,\nProvidence Engineering Team`;
